import config from 'common-module/src/config';

// 检测是否安装
export function checkIsInstallChromeRecorderExtension() {
  const isChrome = window.chrome;

  if (!isChrome) {
    return false;
  }

  return new Promise(
    (resolve) => {
      const image = new Image();
      image.src = `chrome-extension://${config.VUE_APP_RECORDER_EXTENSION_ID}/images/extension.png`;
      image.onload = () => {
        resolve(true);
      };
      image.onerror = () => {
        resolve(false);
      };
    }
  );
  
}